/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsIcMemoryUsageFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsIcMemoryUsageFormat = ClosedEnum<
  typeof GetApiV3MetricsIcMemoryUsageFormat
>;

export type GetApiV3MetricsIcMemoryUsageRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsIcMemoryUsageFormat | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsIcMemoryUsageFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsIcMemoryUsageFormat
> = z.nativeEnum(GetApiV3MetricsIcMemoryUsageFormat);

/** @internal */
export const GetApiV3MetricsIcMemoryUsageFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsIcMemoryUsageFormat
> = GetApiV3MetricsIcMemoryUsageFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsIcMemoryUsageFormat$ {
  /** @deprecated use `GetApiV3MetricsIcMemoryUsageFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsIcMemoryUsageFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsIcMemoryUsageFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsIcMemoryUsageFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsIcMemoryUsageRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsIcMemoryUsageRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsIcMemoryUsageFormat$inboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/** @internal */
export type GetApiV3MetricsIcMemoryUsageRequest$Outbound = {
  start: number | null;
  subnet: string | null;
  end: number | null;
  format: string;
  step: number;
};

/** @internal */
export const GetApiV3MetricsIcMemoryUsageRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsIcMemoryUsageRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsIcMemoryUsageRequest
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsIcMemoryUsageFormat$outboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsIcMemoryUsageRequest$ {
  /** @deprecated use `GetApiV3MetricsIcMemoryUsageRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsIcMemoryUsageRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsIcMemoryUsageRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsIcMemoryUsageRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsIcMemoryUsageRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsIcMemoryUsageRequest$Outbound;
}

export function getApiV3MetricsIcMemoryUsageRequestToJSON(
  getApiV3MetricsIcMemoryUsageRequest: GetApiV3MetricsIcMemoryUsageRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsIcMemoryUsageRequest$outboundSchema.parse(
      getApiV3MetricsIcMemoryUsageRequest,
    ),
  );
}

export function getApiV3MetricsIcMemoryUsageRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsIcMemoryUsageRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsIcMemoryUsageRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsIcMemoryUsageRequest' from JSON`,
  );
}
